import { render, staticRenderFns } from "./PosOperationsReport.vue?vue&type=template&id=af8b4008&"
import script from "./PosOperationsReport.vue?vue&type=script&lang=js&"
export * from "./PosOperationsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports